module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("TfW7Z"))).then(() => parcelRequire('d0iPb'));